import React from "react";
import { Box, Grid, Typography } from "@mui/material";
// import { Grid, Typography } from "@material-ui/core";
import { InputField, DatePickerField } from "../../FormFields";
import { DropzoneArea } from "material-ui-dropzone";

export default function EducationBackground(props) {
  const {
    formField: {
      nameOfTheBachelorDegree,
      graduatedUniversityInstituteBachelorDegree,
      countryBachelorDegree,
      dateOfBachelorDegreeGraduation,
      nameOfMasterDegree,
      graduatedUniversityInstituteMasterDegree,
      countryMasterDegree,
      dateOfMasterDegreeGraduation,
      doctoralDegreeBackground,
      graduatedUniversityInstituteDoctoral,
      countryDoctoral,
      dateGraduationDoctoral
    }
  } = props;

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Educational Background
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <InputField
            name={nameOfTheBachelorDegree.name}
            label={nameOfTheBachelorDegree.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={graduatedUniversityInstituteBachelorDegree.name}
            label={graduatedUniversityInstituteBachelorDegree.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={countryBachelorDegree.name}
            label={countryBachelorDegree.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePickerField
            name={dateOfBachelorDegreeGraduation.name}
            label={dateOfBachelorDegreeGraduation.label}
            inputFormat="dd/MM/yyyy"
            minDate={new Date("1950/12/31")}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <InputField
            name={nameOfMasterDegree.name}
            label={nameOfMasterDegree.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={graduatedUniversityInstituteMasterDegree.name}
            label={graduatedUniversityInstituteMasterDegree.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={countryMasterDegree.name}
            label={countryMasterDegree.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePickerField
            name={dateOfMasterDegreeGraduation.name}
            label={dateOfMasterDegreeGraduation.label}
            inputFormat="dd/MM/yyyy"
            minDate={new Date("1950/12/31")}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <InputField
            name={doctoralDegreeBackground.name}
            label={doctoralDegreeBackground.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={graduatedUniversityInstituteDoctoral.name}
            label={graduatedUniversityInstituteDoctoral.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={countryDoctoral.name}
            label={countryDoctoral.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePickerField
            name={dateGraduationDoctoral.name}
            label={dateGraduationDoctoral.label}
            inputFormat="dd/MM/yyyy"
            minDate={new Date("1950/12/31")}
          />
        </Grid>

        {/* <Grid item xs={12} sm={12}>
          <InputField
            name={graduatedPhdDegreeFromUniversityInstitute.name}
            label={graduatedPhdDegreeFromUniversityInstitute.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={countryOfThePhdDegreeUniversityInstitute.name}
            label={countryOfThePhdDegreeUniversityInstitute.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <DatePickerField
            name={dateOfPhdDegreeGraduation.name}
            label={dateOfPhdDegreeGraduation.label}
            format="dd/MM/yyyy"
            views={["year", "month", "date"]}
            minDate={new Date("1980/12/31")}
            maxDate={new Date()}
            fullWidth
            inputVariant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={workingExperience.name}
            label={workingExperience.label}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={publication.name}
            label={publication.label}
            fullWidth
            multiline
            rows={3}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={awards.name}
            label={awards.label}
            fullWidth
            multiline
            rows={3}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <DropzoneArea
            showFileNames={true}
            dropzoneText={cvOrResume.label}
            onChange={(files) => console.log("Files:", files)}
          />
        </Grid> */}
      </Grid>
    </>
  );
}
